// extracted by mini-css-extract-plugin
export default {"container":"Download_container__A7+MX","innerContainer":"Download_innerContainer__6bg5Y","phoneImage":"Download_phoneImage__-xA5J"};